module.exports = __webpack_public_path__ + "img/gray.614a2b6d.svg";